"use client";

import { useIsomorphicLayoutEffect } from "#/hooks/common/useIsomorphicLayoutEffect.ts";
import { useMediaQuery } from "#/hooks/common/useMediaQuery.ts";
import { useTradeMetaSync } from "../hooks/use-trade-meta-sync";
import { useTradeTitle } from "../hooks/use-trade-title";
import { DesktopTradeLayout } from "./desktop-trade-layout.tsx";
import { MobileTradeLayout } from "./mobile-trade-layout.tsx";

export function TradeLayout() {
	useTradeTitle();
	useTradeMetaSync();
	const isMobile = useMediaQuery("(max-width: 639px)");

	useIsomorphicLayoutEffect(() => {
		document.body.classList.add("trade-page");
		return () => document.body.classList.remove("trade-page");
	}, []);

	return isMobile ? <MobileTradeLayout /> : <DesktopTradeLayout />;
}
